import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { strings } from '/imports/strings';
import { verifyEmailJwt } from '/imports/api/users';
import { PublicFooter } from '/imports/ui/PublicFooter';
import { SignedOutPageStyled } from '/imports/ui/SignedOutPage';
import { Logo } from '/imports/ui/Logo';
import { LoadingFlex } from '/imports/ui/LoadingFlex';

export const VerifyEmailPageStyled = styled(SignedOutPageStyled)`
`;

/** Verifies an email via the JWT in the URL and shows the result. */
export const VerifyEmailPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jwt = params.get('jwt');
  const [verifying, setVerifying] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        await verifyEmailJwt.call(jwt);
      }
      catch (error) {
        console.log(error);
        setError(true);
      }
      finally {
        setVerifying(false);
      }
    })();
  }, []);
  if (verifying) return <LoadingFlex />;
  return (
    <VerifyEmailPageStyled className="page">
      <div className="wrapper">
        <div className="inner-wrapper">
          <div><Logo size={2} /></div>
          <div>
            <h2>{strings.EmailVerification()}</h2>
            <div>
              {
                error ?
                  strings.InvalidOrExpiredVerificationToken()
                  :
                  strings.ThankYouYourEmailHasBeenVerified()
              }
            </div>
          </div>
          <span>
            <Link className="login-link" to='/login'>{strings.GoToLogin()}</Link>
          </span>
        </div>
      </div>
      <PublicFooter />
    </VerifyEmailPageStyled>
  );
};